/** Trùng với SITE_URL trong api/og.ts — ảnh OG luôn qua proxy trên domain chính. */
const OG_SITE_ORIGIN = "https://www.khoancocnhoivietnam.vn";

function utf8ToHex(s: string): string {
  const bytes = new TextEncoder().encode(s);
  let hex = "";
  for (let i = 0; i < bytes.length; i++) {
    hex += bytes[i]!.toString(16).padStart(2, "0");
  }
  return hex;
}

/** og:image cho Helmet: Facebook/Zalo không tải ImgBB trực tiếp ổn định → proxy server. */
export function ogImageForMeta(imageUrl: string, fallbackUrl: string): string {
  const u = (imageUrl || fallbackUrl).trim();
  if (!u.startsWith("http")) return fallbackUrl.trim();
  try {
    if (new URL(u).origin === new URL(OG_SITE_ORIGIN).origin) return u;
  } catch {
    return fallbackUrl.trim();
  }
  return `${OG_SITE_ORIGIN}/api/image-proxy?h=${utf8ToHex(u)}`;
}
